<template>
  <div class="campaign-client-filter-update">
    <label>Filter By Client</label>
    <el-select
      :key="selectComponentKey"
      class="select-primary"
      size="large"
      placeholder="Select Client"
      filterable
      default-first-option
      :loading="isSelectBusy"
      :disabled="isSelectBusy"
      v-model="boundGroupId"
      @change="onGroupFilterChange"
      @visible-change="onGroupSelectVisibleChange"
    >
      <el-option
        v-for="item in companyGroupList"
        class="select-primary"
        :key="formatGroupOptionValue(item)"
        :value="formatGroupOptionValue(item)"
        :label="formatGroupOptionLabel(item)"
      ></el-option>
    </el-select>
  </div>
</template>

<script>
import { Select, Option } from 'element-ui';

export default {
  name: 'select-client-dropdown-dashboard',
  props: {
    isNotRefresh: Boolean,
  },
  components: {
    [Option.name]: Option,
    [Select.name]: Select,
  },
  props: {
    isNotRefresh: Boolean,
    isGroupListLoading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedGroupId: '',
    };
  },
  computed: {
    companyGroupList() {
      const list = this.$global.selectsGroupCompany.companyGroupList;
      return Array.isArray(list) ? list : [];
    },
    isGroupListUnavailable() {
      return this.$global.selectsGroupCompany.companyGroupList == null;
    },
    isResolvingStoredSelection() {
      if (this.isGroupListUnavailable) {
        return true;
      }
      const storedId = this.getStoredGroupId();
      if (!storedId) {
        return false;
      }
      if (!this.companyGroupList.length) {
        return true;
      }
      return !this.hasGroupOption(storedId);
    },
    isSelectBusy() {
      return this.isGroupListLoading || this.isResolvingStoredSelection;
    },
    selectComponentKey() {
      const busy = this.isSelectBusy ? 'busy' : 'ready';
      return `client-group-select-${busy}-${this.companyGroupList.length}`;
    },
    boundGroupId: {
      get() {
        if (this.isSelectBusy) {
          return null;
        }
        const validId = this.resolveValidGroupId();
        return validId === '' ? null : validId;
      },
      set(val) {
        this.selectedGroupId = val == null || val === '' ? '' : String(val);
      },
    },
  },
  watch: {
    companyGroupList() {
      this.applyValidSelection();
    },
    isGroupListLoading(loading) {
      if (!loading) {
        this.$nextTick(() => this.applyValidSelection());
      }
    },
    isResolvingStoredSelection(resolving) {
      if (!resolving) {
        this.$nextTick(() => this.applyValidSelection());
      }
    },
  },
  methods: {
    getStoredGroupId() {
      const stored = localStorage.getItem('companyGroupSelected');
      if (stored == null || stored === '') {
        return '';
      }
      return String(stored);
    },
    hasGroupOption(groupId) {
      return this.companyGroupList.some(item => String(item.id) === String(groupId));
    },
    formatGroupOptionValue(item) {
      return String(item.id);
    },
    formatGroupOptionLabel(item) {
      if (item.group_name == null || item.group_name === false) {
        return '';
      }
      return String(item.group_name);
    },
    resolveValidGroupId() {
      const storedId = this.getStoredGroupId();
      if (!storedId || !this.companyGroupList.length) {
        return '';
      }
      return this.hasGroupOption(storedId) ? storedId : '';
    },
    applyValidSelection() {
      this.selectedGroupId = this.isSelectBusy ? '' : this.resolveValidGroupId();
    },
    onGroupSelectVisibleChange(visible) {
      if (!visible) {
        this.$nextTick(() => this.applyValidSelection());
      }
    },
    onGroupFilterChange(value) {
      const nextValue = value == null || value === '' ? '' : String(value);
      if (!nextValue || this.hasGroupOption(nextValue)) {
        this.selectedGroupId = nextValue;
        localStorage.setItem('companyGroupSelected', nextValue);
        if (this.isNotRefresh) {
          this.$emit('on-filter', nextValue);
          return;
        }
        this.$router.go();
        return;
      }
      this.applyValidSelection();
    },
  },
  mounted() {
    this.applyValidSelection();
  },
};
</script>
